export interface Pagination {
  pageOffset: number;
  pageSize: number;
  resultTotal: number;
  total: number;
}

export interface Media {
  url: string;
}

export interface ApiErrorResponse {
  errors: { code: number; detail: string; title: string }[];
}

export enum ChipBg {
  PRIMARY = "primary",
  WHITE = "white",
  TRANSPARENT = "transparent",
  GRAY = "gray",
}
